import React, { createRef } from 'react';
import { Icon, Dialog } from '@tencent/spaui';
import { Tags } from '../../../consts/Tags';
import { RPCFactory } from '../../../utils/RequestUtil';
import LeadsEditableFieldType from '../../../consts/LeadsEditableFieldType';
import { store } from '../../../store/Store';
import { LeadsManageAction } from '../../../actions/LeadsManageAction';
import { connect } from 'react-redux';
import _ from 'lodash';

import { isSubAccount } from '../../../consts/multiAccountConfig';
import { LeadsTagSelector } from './LeadsTagSelector';
import { beaconInstance } from '../../../instrumentation/beaconSetup';
import { judgeIsFromTMC } from '../../../utils';
import { isLeadsRole } from '../../../utils/routes';

const mapStateToProps = (state) => ({ ...state.leadsManage, industryState: state.global });

class LeadsDialogHeader extends React.Component {
  componentWillReceiveProps(nextProps) {
    this.ownerId = nextProps.ownerId;
    // 更新单条leads信息
    if (
      this.props.updateType !== nextProps.updateType ||
      this.props.targetValue !== nextProps.targetValue ||
      this.props.leadsId == nextProps.targetLeadsId
    ) {
      const { contact } = this.state;
      switch (nextProps.updateType) {
        case LeadsEditableFieldType.NAME:
          contact.name = nextProps.targetValue;
          this.setState({ contact });
          break;
        case LeadsEditableFieldType.TEL:
          contact.tel = nextProps.targetValue;
          this.setState({ contact });
          break;
      }
    }
    if (this.props.oneToOneTag !== nextProps.oneToOneTag) {
      this.setState({ oneToOneTag: nextProps.oneToOneTag });
    }
    if (this.props.tags !== nextProps.tags) {
      this.setState({ selectedTag: nextProps.tags });
    }
  }

  componentDidMount() {
    RPCFactory.leadsManage.getLeadsContactInfo(window.pageProps.uid, this.props.leadsId).done((data) => {
      this.setState({ contact: data });
    });
  }

  /**
   *
   * @param props
   * props.leadsId
   */
  constructor(props) {
    super(props);
    this.state = {
      contact: {},
      oneToOneTag: this.props.oneToOneTag,
      intentionTagDisable: false,
      editModel: false,

      followTagDisable: false,
      editFollowTagModel: false,
      showTagSelect: false,
      showDeleteDialog: false,
      shouldShowAddLabelDialog: false,
      deleteData: {},
      selectedTag: props.tags,
      showRecycleDialog: false,
      recycling: false,
    };
    this.isLabelEditable = window.pageProps.privileges.indexOf('LEADS_TAG_RELATION_MANAGE') !== -1;
    this.recycleBtnRef = createRef();
    this.canRecycle = isLeadsRole('管理员', '超级管理员') && this.props.leadsTab !== 'pool';
  }

  /**
   * 线索评分编辑态
   * @param e
   */
  showEditModel = (e) => {
    this.setState({ editModel: true });
  };
  /**
   * 线索线索状态编辑态
   * @param e
   */
  showEditFollowTagModel = (e) => {
    this.setState({ editFollowTagModel: true });
  };

  hideAddLabelDialog = () => {
    this.setState({ shouldShowAddLabelDialog: false });
  };
  setSelectedTag = (tags) => {
    this.setState({ selectedTag: tags });
  };
  clearIntentionTag = () => {
    this.changeIntentionTag({}, 0);
  };

  /**
   * 更新线索意向度评分
   * @param event
   * @param value
   */
  changeIntentionTag = (event, value) => {
    this.setState({ intentionTagDisable: true });

    RPCFactory.leadsManage
      .updateLeadsIntentionTag(window.pageProps.uid, this.props.leadsId, value)
      .done((data) => {
        const oneToOneTag = { ...this.state.oneToOneTag };
        oneToOneTag.leadsIntentionScoreTag = value;
        this.setState({ oneToOneTag });
        this.setState({ intentionTagDisable: false, editModel: false });

        store.dispatch({
          type: LeadsManageAction.UPDATE_SINGLE_LEADS,
          updateType: LeadsEditableFieldType.INTENTION,
          targetValue: value,
          targetLeadsId: this.props.leadsId,
        });
      })
      .fail((code, msg) => {
        window.alert(`更新失败,${msg}`);
        this.setState({ intentionTagDisable: false, editModel: false });
      });
  };

  selectLeadsTagHandler() {
    // if (isSubAccount()) {
    // 	window.alert ("您没有权限更新线索状态！");
    // 	return;
    // }
    if (this.props.isTestData) return;
    const canMarkPercentAndUpdateStatus = true;

    if (canMarkPercentAndUpdateStatus) {
      this.setState({
        showTagSelect: !this.state.showTagSelect,
      });
    } else {
      window.alert('您没有权限更新线索状态！');
    }
  }
  confirmSelectTagHandle(item) {
    const value = parseInt(item.value);
    this.setState({ followTagDisable: true });

    const labelMap = {};
    _.get(this.props, 'industryState.stateQueryOptions', []).forEach((elm) => {
      labelMap[elm.value] = elm.label;
    });
    const leadsFollowTagName = labelMap[value];

    RPCFactory.leadsManage
      .updateLeadsFollowTag(this.props.leadsId, value)
      .done((data) => {
        const oneToOneTag = { ...this.state.oneToOneTag, leadsFollowTagName };
        oneToOneTag.leadsFollowTag = value;
        this.setState({ oneToOneTag });
        this.setState({ followTagDisable: false, showTagSelect: false });
      })
      .fail((code, msg) => {
        window.alert(`更新失败,${msg}`);
        this.setState({ followTagDisable: false });
      });
  }
  deleteLabel = (data) => {
    this.setState({ showDeleteDialog: true, deleteData: data });
  };
  handleDeleteTag = () => {
    this.setState({ showDeleteDialog: false });
    const tagsId = [this.state.deleteData.tagId];
    const newSelected = [...this.state.selectedTag];
    const index = newSelected.findIndex((item) => item.tagId === this.state.deleteData.tagId);
    RPCFactory.leadsManage
      .deleteLeadsLabel(this.props.leadsId, tagsId)
      .done((data) => {
        newSelected.splice(index, 1);
        this.setSelectedTag(newSelected);
      })
      .fail((code, msg) => {
        window.alert(`删除失败,${msg}`);
      });
  };
  addLabel = (data) => {
    this.setState({ shouldShowAddLabelDialog: true });
  };
  handleClose = () => {
    this.setState({
      showDeleteDialog: false,
    });
  };
  handleRecycle = () => {
    this.setState({ showRecycleDialog: true });
    beaconInstance.onUserAction(
      'btn_click',
      { page: '线索管理', name: '线索回收' },
    );
  };
  cancelRecycle = () => {
    this.setState({
      showRecycleDialog: false,
      recycling: false,
    });
  };
  recycleLeads = () => {
    const { leadsId } = this.props;
    const successCallback = () => {
      const oneToOneTag = {
        ...this.state.oneToOneTag,
        leadsFollowTag: 999,
      };
      this.setState({
        oneToOneTag,
        showRecycleDialog: false,
        recycling: false,
      });
    };
    this.setState({ recycling: true });
    RPCFactory.leadsManage.reclaim({ leadsIds: [leadsId] })
      .done(successCallback)
      .fail((ret, msg) => {
        this.cancelRecycle();
        setTimeout(() => alert(msg));
      });
  };
  getLeadsFollowTags() {
    const currentStateTree = _.get(this.props, 'industryState.currentStateTree', []);
    const arr = [];
    for (const item of currentStateTree) {
      if (!Array.isArray(item.options)) {
        arr.push({ value: item.value, label: item.desc });
        continue;
      }
      item.options.forEach((child) => {
        arr.push({
          value: child.value,
          label: child.desc,
        });
      });
    }
    return arr;
  };
  render() {
    const leadsFollowTagName = this.state.oneToOneTag?.leadsFollowTagName || '未处理';
    const leadsIntentionTags = [];
    Object.keys(Tags.leadsIntentionTag).forEach((key) => {
      leadsIntentionTags.push({ value: key, label: Tags.leadsIntentionTag[key] });
    });
    const leadsFollowTags = this.getLeadsFollowTags();

    const leadsFollowTagsElement = [];
    if (leadsFollowTags && this.state.showTagSelect) {
      leadsFollowTags.forEach((item) => {
        leadsFollowTagsElement.push(
          <li onClick={this.confirmSelectTagHandle.bind(this, item)} className="status-info">
            <span>{item.label}</span>
          </li>,
        );
      });
    }
    this.getLeadsFollowTags();

    const canCall =
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_AGENCY' &&
      window.pageProps.operatorRole != 'OPERATOR_ROLE_LEADS_ADOPERATOR' &&
      !isSubAccount();
    const hasLabel = true;
    const labels = this.state.selectedTag.length > 0 ? this.state.selectedTag : this.props.tags;
    // const labels = [
    //   { type: 'system', labelName: '无效' },
    //   { type: 'self', labelName: '高潜' },
    //   { type: 'self', labelName: '特斯拉' },
    // ];
    return (
      <div className="uname-card">
        <div className="uname clearfix">
          <span
            className="name"
            style={{ 'text-overflow': 'ellipsis', width: '150px', overflow: 'hidden', 'white-space': 'nowrap' }}
          >
            {this.state.contact && this.state.contact.name ? this.state.contact.name : '未命名'}
          </span>
          <div className="ustatus">
            <span
              className={`status-on status-warn${this.props.isTestData ? ' status-test' : ''}`}
              style={{ cursor: this.props.isTestData ? 'default' : 'pointer' }}
              onClick={this.selectLeadsTagHandler.bind(this)}
            >
              {leadsFollowTagName}
              <i className="cssicon-arrow-down"></i>
            </span>
            <div className="status-drop" style={{ padding: '0px', maxHeight: 360, overflowY: 'auto' }}>
              <ul className="status-results">{leadsFollowTagsElement}</ul>
            </div>
          </div>
        </div>
        {canCall && (
          <div>
            <div
              className="phone-num"
              onClick={(event) => this.props.showCallDialog(event, this.state.contact?.tel, this.props.leadsId, this.props.name, this.props.location)}
            >
              <span>{this.state.contact?.tel}</span>
              <i className="icon-phone"></i>
            </div>
            {
              !judgeIsFromTMC() && !!this.ownerId && this.canRecycle && (
                <span
                  className="leads-recycle-btn"
                  ref={this.recycleBtnRef}
                  onClick={this.handleRecycle}
                >
                  线索回收
                </span>
              )
            }
          </div>
        )}

        {!canCall && (
          <div>
            <div className="phone-num">
              <span>{this.state.contact.tel}</span>
            </div>
            {
              !judgeIsFromTMC() && !!this.ownerId && this.canRecycle && (
                <span
                  className="leads-recycle-btn"
                  ref={this.recycleBtnRef}
                  onClick={this.handleRecycle}
                >
                  线索回收
                </span>
              )
            }
          </div>
        )}
        {hasLabel && (
          <div className="label-part">
            <span className="title">线索标签:</span>
            {labels.map((data) => {
              if (!data.customizedTagGroup) {
                return <span className="label-name uneditabled">{data.tagName}</span>;
              }
              return (
                <span className={`label-name ${this.isLabelEditable ? 'editabled' : 'uneditabled'}`}>
                  {data.tagName}
                  {this.isLabelEditable && (
                    <Icon
                      type="close"
                      onClick={() => {
                        this.deleteLabel(data);
                      }}
                    />
                  )}
                </span>
              );
            })}
            {this.isLabelEditable && (
              <span
                className="add-label"
                onClick={() => {
                  this.addLabel();
                }}
              >
                +添加标签
              </span>
            )}
          </div>
        )}
        <Dialog
          show={this.state.showDeleteDialog}
          onClose={this.handleClose}
          onSubmit={this.handleDeleteTag}
          onCancel={this.handleClose}
          title="删除标签"
          style={{
            width: '400px',
          }}
        >
          <div>确定删除此标签？</div>
        </Dialog>
        <LeadsTagSelector
          show={this.state.shouldShowAddLabelDialog}
          hideAddLabelDialog={this.hideAddLabelDialog}
          selected={this.state.selectedTag}
          setSelected={this.setSelectedTag}
          leadsId={this.props.leadsId}
        />
        <Dialog
          type="normal"
          title="确定回收选中线索吗？"
          className="spaui-dialog-confirm-normal"
          eventTarget={this.recycleBtnRef.current}
          show={this.state.showRecycleDialog}
          style={{ width: 400 }}
          onClose={this.cancelRecycle}
          onCancel={this.cancelRecycle}
          onSubmit={this.recycleLeads}
          footerStyle={{ textAlign: 'center' }}
          eventTargetLeftDeviation={-172}
          disabled={this.state.recycling}
        ></Dialog>
      </div>
    );
  }
}

const ReduxLeadsDialogHeader = connect(mapStateToProps)(LeadsDialogHeader);
export default ReduxLeadsDialogHeader;
